import { customFieldsIconMap } from '@/constants/customFieldsIconMap';
import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react';
import { XClose } from '@kula-ai/icons/outline/XClose';
import { ApplicationValue } from './ApplicationValue';
import { MarkdownSubtext } from '@/utils/MarkdownSubtext';

export const ApplicationField = ({
  field,
  ats_attachments = [],
  wrapperProps = {},
}) => {
  const { type, label, kind, description } = field;

  const icon =
    customFieldsIconMap?.[type] || customFieldsIconMap?.[kind] || XClose;

  // if (hidden) return null;

  return (
    <Flex mb="20px" flexDir="column" gap="6px" {...wrapperProps}>
      <Flex alignItems="center" gap="6px">
        <Icon as={icon} w="16px" h="16px" color="primary-500" />
        <Flex flexDir="column">
          <KText
            color="secondary-900"
            size="sm-semi-bold"
            wordBreak="break-all"
          >
            {label}
          </KText>
          {description && (
            <MarkdownSubtext
              markdown={description}
              bodyColor="secondary-500"
              display="inline-block"
              maxW="100%"
              verticalAlign="top"
              bg="transparent"
              p={0}
              m={0}
            />
          )}
        </Flex>
      </Flex>
      <ApplicationValue field={field} ats_attachments={ats_attachments} />
    </Flex>
  );
};
